import useApi from '../../../services/useApi'

const useGetSalesRepTypeDropdown = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/profitability/filters/customer-rep-types'
  )

  return {
    salesRepTypes: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetSalesRepTypeDropdown
